import Loadable from "react-loadable"
import { Loading } from "@/components/Loading"

export const ResetPassword = Loadable({
  loader: () => import("./ResetPassword"),
  loading: Loading
})
